"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jiraInitiativesWatchers = exports.jiraInitiativesReducers = void 0;
const redux_1 = require("redux");
const delete_1 = require("./@async/delete.js");
const get_1 = require("./@async/get.js");
const add_1 = require("./@sync/add.js");
const remove_1 = require("./@sync/remove.js");
const update_1 = require("./@sync/update.js");
const put_1 = require("./@async/put.js");
const xuder_1 = require("@sonar-software/xuder");
const sync_jira_1 = require("./sync-jira/index.js");
exports.jiraInitiativesReducers = (0, redux_1.combineReducers)({
    delete: delete_1.deleteJiraInitiativesUnlinkIssueSlice.asyncReducers,
    get: (0, xuder_1.joinReducers)([
        get_1.getInitiativesJiraIssueSlice.asyncReducers,
        add_1.initiativesJiraIssueAddSyncSlice.syncReducer,
        remove_1.initiativesJiraIssueRemoveSyncSlice.syncReducer,
        update_1.initiativesJiraIssueUpdateSlice.syncReducer
    ], get_1.getInitiativesJiraIssueSlice.asyncState),
    put: put_1.putJiraInitiativesLinkIssueSlice.asyncReducers,
    sync: sync_jira_1.jiraInitiativesSyncReducers
});
exports.jiraInitiativesWatchers = (0, xuder_1.combineAllWatchers)([
    delete_1.deleteJiraInitiativesUnlinkIssueSlice.asyncWatchers,
    get_1.getInitiativesJiraIssueSlice.asyncWatchers,
    sync_jira_1.jiraInitiativesSyncWatchers,
    put_1.putJiraInitiativesLinkIssueSlice.asyncWatchers
]);
//# sourceMappingURL=index.js.map